import * as _ from "lodash";

import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import GameInstance from "../models/GameInstance.model";

export interface GameInstanceState {
    count: number;
    results: GameInstance[];
    loading: boolean;
    timestamp: Date;
    error: any;
    selected: GameInstance[];
}

const defaultState: GameInstanceState = {
    count: 0,
    results: [],
    loading: false,
    timestamp: null,
    error: null,
    selected: []
};

export function gameInstances(
    state: GameInstanceState = defaultState,
    action: Action
) {
    let newState: GameInstanceState;
    switch (action.type) {
        case ConfigurationsActionTypes.CLEAR_CONFIGURATION:
            return defaultState;
        case ConfigurationsActionTypes.GET_GAME_INSTANCES:
            newState = _.cloneDeep(state);
            newState.loading = true;
            newState.error = null;
            return newState;

        case ConfigurationsActionTypes.GET_GAME_INSTANCES_SUCCESS:
            newState = _.cloneDeep(state);
            newState.count = action.payload.count;
            newState.results = action.payload.results;
            newState.loading = false;
            newState.timestamp = new Date();
            newState.error = null;
            return newState;

        case ConfigurationsActionTypes.GET_GAME_INSTANCES_FAIL:
            newState = _.cloneDeep(state);
            newState.loading = false;
            newState.error = action.payload.error;
            return newState;

        case ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG:
            newState = _.cloneDeep(state);
            if (action.payload.type && action.payload.type == "Game_Group") {
                newState.selected = _.reduce(
                    action.payload.config,
                    (selectGameInstances, group) => {
                        return _.concat(
                            selectGameInstances,
                            group.game_instances
                        );
                    },
                    []
                );
            }
            return newState;
        default:
            return state;
    }
}

export function gameBundles(state: any[] = [], action: Action) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_GAME_BUNDLES_SUCCESS:
            return action.payload.bundles;
        default:
            return state;
    }
}
